import { render, staticRenderFns } from "./PartitionValuationBySupplier.vue?vue&type=template&id=9c8569a2&scoped=true"
import script from "./PartitionValuationBySupplier.vue?vue&type=script&lang=js"
export * from "./PartitionValuationBySupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8569a2",
  null
  
)

export default component.exports